// Веб-вклад модуля `materials` — источники.
//
// Собственного пункта навигации у раздела НЕТ: `/materials` подсвечивает
// «Библиотеку» (карточка источника живёт под старым адресом). Вклад в витрину
// дашборда — две плитки-действия: загрузка файла и поиск в интернете (Discover).

import { IconWorldSearch } from "@tabler/icons-react";
import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const materialsWebManifest = {
	id: "materials",
	icon: SECTION_ICONS.materials,
	labelKey: "nav.materials",
	category: SECTION_CATEGORY.materials,
	routes: ["/materials"],

	launch: [
		{
			key: "upload",
			icon: SECTION_ICONS.upload,
			tint: SECTION_TINT.upload,
			titleKey: "launcher.upload",
			hintKey: "launcher.uploadHint",
			action: "upload",
			accent: true,
			order: 60,
		},
		{
			key: "discover",
			icon: IconWorldSearch,
			tint: "violet",
			titleKey: "launcher.discover",
			hintKey: "launcher.discoverHint",
			action: "discover",
			order: 70,
		},
	],
} satisfies WebModuleManifest;
